import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { EventRecord, UpdateEventRequest } from "../EventRecord";

import { eventQueryKeys } from "./eventQueryKeys";

export function useUpdateEvent() {
  const { events } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    EventRecord,
    Error,
    { id: string; requestBody: UpdateEventRequest }
  >({
    mutationFn: ({ id, requestBody }) => {
      return events.updateEvent(id, requestBody);
    },
    onSuccess: (updatedEvent) => {
      queryClient.setQueryData(
        eventQueryKeys.detail(updatedEvent.event_id),
        updatedEvent,
      );
      void queryClient.invalidateQueries({ queryKey: eventQueryKeys.lists() });
      void queryClient.invalidateQueries({
        queryKey: eventQueryKeys.forWorkspaces(),
      });
      // Invalidate all dataset event queries rather than just the event's direct
      // dataset associations: events can be associated to files whose dataset we
      // don't know without an extra fetch, and those events still surface in
      // dataset views.
      void queryClient.invalidateQueries({
        queryKey: eventQueryKeys.forDatasets(),
      });
    },
  });
}
